<div #modalElement
     [id]="getId()"
     class="modal class-sharing-modal"
     data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Klasse informieren</h4>
                <button class="close-button float-end" data-bs-dismiss="modal" title="Schließen" type="button">
                    <i aria-hidden="true" class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="mb-3 text-start">
                    <label class="form-label" for="title">Titel:</label>
                    <input [(ngModel)]="title" class="form-control" id="title"
                           name="notify_school_class_title" placeholder="Titel der Nachricht ..." type="text"/>
                </div>
                <div class="mb-3 text-start">
                    <label class="form-label" for="message">Nachricht:</label>
                    <textarea [(ngModel)]="message" class="form-control" id="message"
                              name="notify_school_class_message" placeholder="Deine Nachricht ..."
                              type="text"></textarea>
                </div>
                    <div class="mb-3 text-start">
                        <label class="form-label" for="schoolClasses">Klasse:</label>
                        <select #classSelect [(ngModel)]="class" class="form-select" id="schoolClasses"
                                name="school_class"
                                required="">
                            <option [disabled]="true" [ngValue]="null">Wähle eine Klasse...</option>
                            @for (schoolClass of applicationStateService.schoolClassList; track schoolClass) {
                                <option
                                        [value]="schoolClass.id">
                                    {{ schoolClass.name }} - {{ schoolClass.group }}
                                </option>
                            }
                        </select>
                    </div>
            </div>
            @if (errMsg) {
                <div class="alert alert-warning well-sm">
                    {{ errMsg }}
                </div>
            }
            <div class="modal-footer platform">
                <button (click)="notify()" class="approve-platform-link-btn">
                    Senden
                </button>
            </div>
        </div>
    </div>
</div>
